<template>
  <!-- <v-layout>
      <h1>Fixed Cost #{{$route.params.id}}</h1>
  </v-layout>-->
  <v-layout justify-center row>
    <v-flex xs2>
      <SimpleCard>
        <DriverDocumentsSearchBox
          @search="search"
          @clear="clear"
          :query="query"
          @checkForExpiredDocuments="checkForExpiredDocuments"
        ></DriverDocumentsSearchBox>
      </SimpleCard>
    </v-flex>
    <v-flex xs10 pl-2> 
      <SimpleCard>
        <v-layout row wrap align-content-center justify-center>
          <DriverDocumentsList
            ref="driverDocsList"
            v-if="!loading"
            style="width: 100%"
            @refresh="refresh"
            :pagination="pagination"
            :query="query"
          ></DriverDocumentsList>
        </v-layout>
      </SimpleCard>
    </v-flex>
  </v-layout>
</template>

<script>
import SimpleCard from "@/components/widget/SimpleCard.vue";
import DriverDocumentsList from "@/components/driver/DriverDocumentsList.vue";
import DriverDocumentsSearchBox from "@/components/driver/DriverDocumentsSearchBox.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "drivers",
  components: {
    SimpleCard,
    DriverDocumentsList,
    DriverDocumentsSearchBox,
  },
  data: function () {
    return {
      offset: 0,
      count: 20,
      query: {
        filter: "pending",
        lockedOut: false,
      },
      numPages: 0,
      driverPhotos: [],
      loading: false,
    };
  },
  methods: {
    checkForExpiredDocuments: async function () {
      var self = this;

      try {
        alert(
          "This make take a long time. Please check back after a few minutes"
        );

        let response = await axios.post(
          `${this.$store.state.apiUrl}/driver_document_expiry/calculateExpiries`,
          {},
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );

        this.$refs.driverDocsList.refresh();
      } catch (error) {
        console.log(error);
        return "unknown_error";
      }

      this.$refs.driverDocsList.refresh();
    },
    search: function () {
      console.log("Search");
      this.$refs.driverDocsList.clearAndRefresh();
    },
    refresh: function () {
      this.$refs.driverDocsList.refresh();
    },
    failed: function (data) {
      alert("Request Failed with error: " + data.message);
    },
  },
};
</script>
